import { OnboardingStateType } from './OnboardingProvider';
import { OnboardingActions } from './Onboarding.actions';
import { Reducer } from 'react';
import updateImmutable from 'immutability-helper';
import { completeOnboardingReducer } from './reducers/completeOnboarding.reducer';
import { gotoStepReducer } from './reducers/gotoStep.reducer';
import { toggleTourTipReducer, tooltipRegisterReducer } from './reducers/tooltip.reducer';
import { seenStepsReducer } from './reducers/seenSteps.reducer';

export const OnboardingReducer: Reducer<OnboardingStateType, OnboardingActions> = (state, action) => {
  const { type } = action;
  switch (type) {
    case 'completeOnboarding': {
      return completeOnboardingReducer(state, action.payload);
    }
    case 'completeTour': {
      return updateImmutable(state, {
        isCongrats: { $set: true }
      });
    }
    case 'gotoStep': {
      return gotoStepReducer(state, action.payload);
    }
    case 'registerTourtip': {
      return tooltipRegisterReducer(state, action.payload);
    }
    case 'setActiveStepIndex': {
      return updateImmutable(state, {
        activeStepIndex: { $set: action.payload }
      });
    }
    case 'setDemoCategoryAndProfiles': {
      return updateImmutable(state, {
        demoCategoryId: { $set: action.payload.categoryId },
        selectedProfiles: { $set: action.payload.profiles }
      });
    }
    case 'setSeenSteps': {
      return seenStepsReducer(state, action.payload);
    }
    case 'toggleExpanded': {
      return updateImmutable(state, {
        expanded: { $apply: current => (action.payload !== undefined ? action.payload : !current) }
      });
    }
    case 'toggleTourTip': {
      return toggleTourTipReducer(state, action.payload);
    }
    default:
      return state;
  }
};
